async function LoginIdGenerator() {
  const response = await fetch('/bizcareui/api/Registration/loginId');
  const data = await response.json();
  const nextVal  = data.result;
  // const result = data.result[0];
  // const nextVal = result['NEXTVAL(login_sequence)'];

  const sequenceNumber = process.env.NEXT_PUBLIC_SEQUENCE_NUMBER

  const loginId = 'BIZC' + (parseInt(sequenceNumber) + nextVal);
  // const loginId = "BIZC1000" + nextVal;
  // const loginId = "BIZC1000" + (data.result[0].sequenceNum + 1); //old - take max num
  return loginId;
}

export default LoginIdGenerator;
